import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Stack } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { ISortingProps } from './types';
import _ from 'lodash';

export default function Sorting({ onChange, sortingItems, defaultValue }: ISortingProps) {
  
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  return (
    <div>
      <Stack flexDirection='row' sx={{justifyContent: 'end'}}>
        <FormControl sx={{ m: 1, minWidth: 223, maxWidth: 223}
        }>
          <Select
            MenuProps={{ disablePortal: true }}  
            defaultValue={defaultValue}
            value={defaultValue}
            onChange={handleChange}
            displayEmpty
            inputProps={{ 'aria-label': 'label' }}
            sx={{'&.MuiInputBase-root': { borderRadius: '24px'}}}
          >
            {_.map(sortingItems, item=>{ 
              return <MenuItem key={item.id} value={item.id}>{item.label}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </Stack>
    </div>
  );
}
